import {Component, Input} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";

@Component({
  selector: 'app-data',
  templateUrl: './data.component.html',
  styleUrls: ['../../sign-up.component.scss'],
})
export class DataComponent {

    @Input() isClient= false;

    @Input() dataForm: UntypedFormGroup = new UntypedFormGroup({
       name: new UntypedFormControl(null, Validators.required),
       surname: new UntypedFormControl(null, Validators.required),
       nif: new UntypedFormControl(null)
    });

}
